export enum GlobalRoles {
    SYSTEM_ADMIN = 'SystemAdmin'
}
